import React, { useEffect, useMemo, useState } from "react";
import { DOMAIN_ID, getUserName, ORG_ID } from "../../utils/helpers";
import { Avatar, Button, Card, message, Spin } from "antd";
import { AppContentLayout } from "../../layout/applayout";
import { getWalletUserList } from "../../service/didService";
import SelfEnrollModal from "../../components/enrollment/SelfEnrollModal";

function ProfilePage() {
  const userEmail = getUserName();
  const [messageApi, contextHolder] = message.useMessage();
  const [profileData, setProfileData] = useState([]);
  const [userName, setUserName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // Self-enrollment QR. Opened on click only — the call mints a token, so it must
  // not fire while this page is merely rendering.
  const [selfEnrollOpen, setSelfEnrollOpen] = useState(false);
  const userDetails = useMemo(() => {
    return JSON.parse(localStorage.getItem("userDetails"))
  }, []);

  const tenantDetails = useMemo(() => {
    return JSON.parse(localStorage.getItem("tenantDetails"))
  }, []);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = () => {
    let payload = {
      domainId: DOMAIN_ID(),
      orgId: ORG_ID(),
      pageNumber: 1,
      pageSize: 500,
      filter: userEmail,
    };
    setIsLoading(true);
    getWalletUserList({ payload, onSuccess: handleUserListSuccess, onFailure: handleUserListFailure });
  };

  const handleUserListSuccess = (data) => {
    setIsLoading(false);
    const userData = data?.users[0];
    setUserName(userData?.username);
    setProfileData(userData);
  };

  const handleUserListFailure = () => {
    setIsLoading(false);
    messageApi.open({
      type: "error",
      content: "Unable to fetch profile",
    });
  };
  return (
    <>
      {contextHolder}
      <div className="max-w-6xl mx-auto py-6 space-y-4 h-full">
        <div className="flex flex-col space-y-2.5 justify-center items-center text-center">
          <Avatar className="!size-20 !text-3xl bg-primary">{userName?.charAt(0)?.toUpperCase()}</Avatar>
          <h3 className="text-2xl font-semibold">Welcome, {userName}</h3>
          <p className="text-base">Access and update your profile information with ease.</p>
        </div>
        <AppContentLayout
          children={
            <div className="bg-gray-50 p-6 h-full border border-t-black/20">
              {isLoading ? (
                <div className="flex justify-center items-center w-full">
                  <Spin size="large" />
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Card
                      className="!shadow-sm !drop-shadow-sm flex flex-col justify-between border-black/20"
                      actions={[
                        <div className="flex items-center text-base font-medium space-x-1 !px-4">
                          <h6 className="text-primary">User Info</h6>
                        </div>,
                      ]}
                      classNames={{ body: "!px-4 !py-3", actions: '!border-black/20' }}
                    >
                      <table cellPadding={3}>
                        <tr>
                          <td className="font-semibold text-sm">Name</td>
                          <td className="pl-4">{profileData?.username || "-"}</td>
                        </tr>
                        <tr>
                          <td className="font-semibold text-sm">Email</td>
                          <td className="pl-4">{profileData?.emailAddress || "-"}</td>
                        </tr>
                        <tr>
                          <td className="font-semibold text-sm">Role</td>
                          <td className="pl-4">{userDetails?.UserRole || "-"}</td>
                        </tr>
                      </table>
                    </Card>
                    <Card
                      className="!shadow-sm !drop-shadow-sm  flex flex-col justify-between border-black/20"
                      actions={[
                        <div className="flex items-center text-base font-medium space-x-1 !px-4">
                          <h6 className="text-primary">Organization Info</h6>
                        </div>,
                      ]}
                      classNames={{ body: "!px-4 !py-3", actions: '!border-black/20' }}
                    >
                      <table cellPadding={3}>
                        <tr>
                          <td className="font-semibold text-sm">Name</td>
                          <td className="pl-4">{tenantDetails?.organizationName || "-"}</td>
                        </tr>
                        <tr>
                          <td className="font-semibold text-sm">Zone</td>
                          <td className="pl-4">{tenantDetails?.timezone || "-"}</td>
                        </tr>
                      </table>
                    </Card>
                    {/* Self-enrollment. No third party is involved — this is the
                        signed-in user registering their own device — so it skips
                        the warnings the admin QR carries. */}
                    <Card
                      className="!shadow-sm !drop-shadow-sm flex flex-col justify-between border-black/20"
                      actions={[
                        <div className="flex items-center text-base font-medium space-x-1 !px-4">
                          <h6 className="text-primary">Security</h6>
                        </div>,
                      ]}
                      classNames={{ body: "!px-4 !py-3", actions: '!border-black/20' }}
                    >
                      <div className="space-y-3">
                        <p className="text-sm">
                          Approve sign-ins from your phone with the AuthNull Authenticator.
                        </p>
                        <Button type="primary" onClick={() => setSelfEnrollOpen(true)}>
                          Set up AuthNull Authenticator
                        </Button>
                      </div>
                    </Card>
                  </div>
                </>
              )}
            </div>
          }
        />
      </div>
      {selfEnrollOpen && (
        <SelfEnrollModal
          open={selfEnrollOpen}
          onClose={() => setSelfEnrollOpen(false)}
        />
      )}
    </>
  );
}

export default ProfilePage;
